module.exports = __webpack_public_path__ + "static/img/1425_phase_function_Paper_Points.b0bfd2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1425_phase_function_Paper_Points.png
// module id = hP3m
// module chunks = 0